function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("image", {
  id: "calc.svg",
  "data-name": "calc.svg",
  width: 24,
  height: 26,
  xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAaCAYAAACtv5zzAAACh0lEQVRIib2VW4hOURTHf/M5M4MMxnUepCn3PuRFSeFB0ShFXny5Uy6NmsKDYQrlRS6Ruzx4mDyRa0K5RBRPE3KLDI0kQ99MQonR4v/Vard9zZxi1emcvdY667/X2v+1dklNrjYDjAP6ACWkky/AI+Br+HcCTAZupwzs5RwwJwbQV99XgfUpAs8HNgPVMWPivpcC71IANAggKpkUAbsk/xUgKeKXWnzQa8C2FIHmFTN6gBFA47/M4A5wXN+VwE7gM7AR+KZybgDGAHuAh/KdKar+FcC68CNwCjjhbFuAZuCI000VwH7Z0LsowHV1YWflZ+DXBMyO6H+Lpd0DyAE/nL43UKbsyqSzOdUTuAe0BjEeaKNRgCzQATzXexnQprqXAx+AvM5jEFADfAcWKnMr70XgBrALmB6WaLCm4BDgKDBSu5kGTACuAJ8EvlbZnQGGA/2ATQJv0NrOaIbI0ZEo9f7a3WoH3qYDnOV03QVoQZ6KQS+BUmW1Qxu0f94b2zKq82spvJjubaBbpeAmz4AnQD2wDrgA1Dnf7Xa+BRbFRu34iG55RLdV7wrgoNMbeUYbwChgjc6hXrfbiiDISdExGwHYrfOxfpkY2KoSjYg61dwAhgWpouDWud0iAPukz4tJza4ipZ0d10OVYWvE9gZ4pTM0shxztvZEjTNXLMCtvRTGwiVgcWDLi4lG5Xagl7O9SNRIZ6UYCwxQwCalWq17u0I0zImW5fqn0gXMOqrfBFrCEjWqjnu1tnva1vYcBh4DtbJZM90S2yYB9zUyrNmsbIvMqSu32ALgLnBI5TgATNGYsIyq5HceWFnoqxBgicphdTWx++Fy4GM1Pq2y2ngZ6MZ+i8D/CPALlFiQUd269vgAAAAASUVORK5CYII="
});

function SvgCalc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalc);
export default __webpack_public_path__ + "static/media/calc.8d828ab3.svg";
export { ForwardRef as ReactComponent };